import {element, CustomElement} from "./CustomElement";
import {i18n} from "../i18n/I18n";

export function register() {
	element("flipp-price")(PriceElement);
}

class PriceElement extends CustomElement {
	get value(): string {
		return this.getAttribute("value");
	}

	set value(value: string) {
		this.setAttribute("value", value);
	}

	protected attributeChangedCallback(attr: string) {
		if (attr === "value")
			this._render();
	}

	private _render() {
		while (this.hasChildNodes())
			this.removeChild(this.firstChild);
		this.removeAttribute("role");
		this.removeAttribute("aria-label");
		this.removeAttribute("zero-dollars");
		this.removeAttribute("zero-cents");

		let price = this.value;
		if (!price)
			return;

		const matchWithoutCents = price.match(/^\s*([-&])?\s*(\$)?\s*(\d+)\s*$/);
		if (matchWithoutCents) {
			price += ".00";
		}

		const match = price.match(/^\s*([-&])?\s*(\$)?\s*(\d+)\.(\d+)\s*$/);
		if (!match)
			return;

		const dollars = match[3];
		if (!parseInt(dollars, 10))
			this.setAttribute("zero-dollars", "");

		let cents = match[4];
		if (!cents)
			cents = "00";
		else if (cents.length === 1)
			cents += "0";
		else if (cents.length > 2)
			cents = cents.substr(0, 2);

		if (cents === "00")
			this.setAttribute("zero-cents", "");

		this.setAttribute("role", "img");
		this.setAttribute("aria-label", i18n(
				"x_dollars_n_cents", { x: dollars, n: cents }));

		/* Disable virtual DOM rendering. The code below will render a VNode in DOM if not disabled */
		flipp.setVirtualDOM(false);
		if (match[1])
			this.appendChild(document.createTextNode(match[1]));
		this.appendChild(
				flipp.createFragment(<span class="dollars">{dollars}</span>,
												<span class="cents">{cents}</span>));
	}
}
